<template>
  <card-seplag titulo="Formulários da Prefeitura de Cuiabá" cor="#00acc1">
    <Panel header="1. Dados Pessoais" class="p-col-12">
      <div class="p-grid p-col-12">
        <Rotulo nome="1.1 NOME:" cols="12 8">
          <InputText
            type="text"
            v-model="registro.nomePessoa"
            placeholder="Nome"
            disabled
          />
        </Rotulo>
        <Rotulo nome="1.2 CPF:" cols="12 4">
          <InputText
            type="text"
            v-model="registro.cpfFormatado"
            placeholder="CPF"
            disabled
          />
        </Rotulo>
        <Rotulo nome="1.3 DATA DE NASCIMENTO:" cols="12 4">
          <InputMask
            v-model="registro.dataNascimento"
            mask="99/99/9999"
            placeholder="99/99/9999"
            v-required
          />
        </Rotulo>
        <Rotulo nome="1.4 TELEFONE:" cols="12 4">
          <InputMask
            v-model="registro.numrTelefone"
            mask="(99)99999999?9"
            :autoClear="false"
            placeholder="(99)99999-9999"
            v-required
          />
        </Rotulo>
        <Rotulo nome="1.5 E-MAIL:" cols="12 4">
          <InputText
            type="text"
            v-model="registro.email"
            placeholder="E-mail"
            v-required
            class="toLowerCase"
          />
        </Rotulo>
      </div>
    </Panel>
    <Panel header="2. Endereço" class="p-col-12">
      <div class="p-grid p-col-12">
        <Rotulo nome="2.1 CEP:" cols="12 2">
          <InputText
            type="text"
            v-model="registro.numrCep"
            placeholder="CEP"
            v-required
          />
        </Rotulo>
        <Rotulo nome="2.2 N°:" cols="12 2">
          <InputText
            type="text"
            v-model="registro.numrEndereco"
            placeholder="Nº"
            v-required
          />
        </Rotulo>
        <Rotulo nome="2.3 BAIRRO:" cols="12 8">
          <InputText
            type="text"
            v-model="registro.nomeBairro"
            placeholder="Bairro"
            v-required
            class="toUpperCase"
          />
        </Rotulo>
        <Rotulo nome="2.4 COMPLEMENTO:" cols="12 6">
          <InputText
            type="text"
            v-model="registro.descEndereco"
            placeholder="Complemento"
            class="toUpperCase"
          />
        </Rotulo>
        <Rotulo nome="2.5 UF" cols="12 3">
          <Dropdown
            v-model="registro.uf"
            :options="ufs"
            optionLabel="nomeUf"
            placeholder="Selecione a UF..."
            :filter="true"
            @change="changeUf"
            v-required
          />
        </Rotulo>
        <Rotulo nome="2.6 CIDADE" cols="12 3">
          <Dropdown
            v-model="registro.cidade"
            :options="cidades"
            optionLabel="nomeCidade"
            placeholder="Selecione a cidade..."
            :filter="true"
            @change="changeForm"
            v-required
          />
        </Rotulo>
      </div>
    </Panel>

    <Panel header="3. Vínculo" class="p-col-12">
      <div class="p-grid p-col-12">
        <div class="p-col-12">
          <div class="p-grid p-fluid">
            <Rotulo nome="3.1 UNIDADE DE LOTAÇÃO:" cols="12 6">
              <!--<InputText type="text" v-model="registro.descUnidadeLotacao"  placeholder="UNIDADE DE LOTAÇÃO"  />-->
              <Dropdown
                v-model="registro.descUnidadeLotacao"
                :options="unidades"
                placeholder="Selecione uma Unidade de Lotação"
                disabled
              />
            </Rotulo>
            <Rotulo nome="3.2 CONFIRMA LOTAÇÃO?" cols="12 2">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                  margin-top: 5px;
                "
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    margin: 2px;
                  "
                >
                  <RadioButton
                    inputId="S"
                    name="flagEfetivo"
                    value="S"
                    v-model="registro.flagConfirmaLotacao"
                    @input="limpaCampoLotacao()"
                  />
                  <label for="S" style="margin-left: 10px; margin-right: 10px">
                    Sim</label
                  >
                  <RadioButton
                    inputId="N"
                    name="flagEfetivo"
                    value="N"
                    v-model="registro.flagConfirmaLotacao"
                  />
                  <label for="N" style="margin-left: 10px"> Não</label>
                </div>
              </div>
            </Rotulo>
            <Rotulo
              nome="3.2.1 LOTAÇÃO CORRETA:"
              cols="12"
              v-if="registro.flagConfirmaLotacao == 'N'"
              :requerido="registro.descUnidLotacaoInformada ? true : false"
            >
              <InputText
                type="text"
                v-model="registro.descUnidLotacaoInformada"
                placeholder="Informe a lotação correta"
                class="toUpperCase"
              />
            </Rotulo>
            <Rotulo nome="3.3 CARGO:" cols="12 6">
              <!-- <InputText
                type="text"
                v-model="registro.descCargo"
                placeholder="Cargo"
                disabled
                class= "toUpperCase"
              /> -->
              <Dropdown
                v-model="registro.descCargo"
                :options="cargos"
                placeholder="Selecione o cargo"
              />
            </Rotulo>
            <Rotulo
              nome="3.4. COMO É REALIZADO O REGISTRO DO PONTO?"
              cols="12 6"
            >
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                  margin-top: 5px;
                "
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    margin: 2px;
                  "
                >
                  <RadioButton
                    inputId="PONTO_ELETRONICO"
                    name="tipoRegistroPonto"
                    value="PONTO_ELETRONICO"
                    v-model="registro.tipoRegistroPonto"
                  />
                  <label
                    for="PONTO_ELETRONICO"
                    style="margin-left: 10px; margin-right: 10px"
                  >
                    Ponto Eletrônico</label
                  >
                  <RadioButton
                    inputId="FREQUENCIA_MANUAL"
                    name="tipoRegistroPonto"
                    value="FREQUENCIA_MANUAL"
                    v-model="registro.tipoRegistroPonto"
                  />
                  <label for="FREQUENCIA_MANUAL" style="margin-left: 10px">
                    Registro de Frequência Manual</label
                  >
                </div>
              </div>
            </Rotulo>
            <!-- <Rotulo nome="7. DESCRIÇÃO CARGA HORÁRIA DE TRABALHO:" cols="12 6" >
                    <InputText type="text" v-model="registro.descCargaHoraria"  placeholder="CARGA HORÁRIA/JORNADA"  />
                </Rotulo>  />-->
            <Rotulo nome="3.5 CARGA HORÁRIA DIÁRIA DE TRABALHO:" cols="12 6">
              <InputMask
                v-model="registro.valorCargaHorariaDiaria"
                mask="99hs"
                :autoClear="false"
                placeholder="HHhs"
                v-required
              />
            </Rotulo>
            <Rotulo nome="3.6 CARGA HORÁRIA/SEMANAL DE TRABALHO:" cols="12 6">
              <InputMask
                v-model="registro.valorCargaHorariaSemanal"
                mask="99hs"
                :autoClear="false"
                placeholder="HHhs"
                v-required
              />
            </Rotulo>

            <Rotulo nome="3.7 HORA INÍCIO TRABALHO:" cols="12 6">
              <InputMask
                v-model="registro.horaInicioTrabalho"
                mask="99:99"
                :autoClear="false"
                placeholder="HH:mm"
                v-required
              />
            </Rotulo>
            <Rotulo nome="3.8 HORA FINAL TRABALHO:" cols="12 6">
              <InputMask
                v-model="registro.horaFimTrabalho"
                mask="99:99"
                :autoClear="false"
                placeholder="HH:mm"
                v-required
              />
            </Rotulo>

            <Rotulo nome="3.9 CPF CHEFIA IMEDIATA:" cols="12 4">
              <AutoComplete
                v-model="textoBusca"
                :suggestions="resultadoBusca"
                @complete="searchPessoa($event)"
                @item-select="selecionarChefia($event)"
                field="cpfFormatado"
                placeholder="Pesquise por CPF ou nome..."
                v-required
              >
                <template #item="slotProps">
                  <div>
                    <b>CPF:</b> {{ slotProps.item.cpfFormatado }} - <b>Nome: </b
                    >{{ slotProps.item.nomePessoa }}
                  </div>
                </template>
              </AutoComplete>
            </Rotulo>
            <Rotulo nome="3.10 NOME CHEFIA:" cols="12 8">
              <InputText
                type="text"
                v-model="registro.nomeChefia"
                placeholder="NOME CHEFIA SELECIONADA"
                disabled
                v-required
              />
            </Rotulo>
          </div>
        </div>
        <div class="p-col-12">
          <div class="p-grid p-fluid">
            <Rotulo nome="3.11 MATRÍCULA:" cols="12 4">
              <InputText
                type="text"
                v-model="registro.numrMatricula"
                placeholder="Matrícula"
                v-required
              />
            </Rotulo>
            <Rotulo nome="3.12 EFETIVO?:" cols="12 8">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                  margin-top: 5px;
                "
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    margin: 2px;
                  "
                >
                  <RadioButton
                    inputId="S"
                    name="flagEfetivo"
                    value="S"
                    v-model="registro.flagEfetivo"
                  />
                  <label for="S" style="margin-left: 10px; margin-right: 10px">
                    Sim</label
                  >
                  <RadioButton
                    inputId="N"
                    name="flagEfetivo"
                    value="N"
                    v-model="registro.flagEfetivo"
                  />
                  <label for="N" style="margin-left: 10px"> Não</label>
                </div>
              </div>
            </Rotulo>
            <Rotulo nome="3.13 COMISSIONADO?" cols="12 4">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                  margin-top: 5px;
                "
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    margin: 2px;
                  "
                >
                  <RadioButton
                    inputId="S"
                    name="flagComissionado"
                    value="S"
                    v-model="registro.flagComissionado"
                  />
                  <label for="S" style="margin-left: 10px; margin-right: 10px">
                    Sim</label
                  >
                  <RadioButton
                    inputId="N"
                    name="flagComissionado"
                    value="N"
                    v-model="registro.flagComissionado"
                  />
                  <label for="N" style="margin-left: 10px"> Não</label>
                </div>
              </div>
            </Rotulo>
            <Rotulo nome="3.14 DATA POSSE:" cols="12 4">
              <date-picker
                v-model="registro.dataPosse"
                valueType="format"
                title-format="DD/MM/YYYY"
                format="DD/MM/YYYY"
                class="grid-container"
                :disabled= "registro.flagComissionado === 'N'"
              >
              </date-picker>
            </Rotulo>

            <Rotulo nome="3.15 DATA DE NOMEAÇÃO:" cols="12 4">
              <date-picker
                v-model="registro.dataNomeacao"
                valueType="format"
                title-format="DD/MM/YYYY"
                format="DD/MM/YYYY"
                class="grid-container"
                :disabled= "registro.flagComissionado === 'N'"
              >
              </date-picker>
            </Rotulo>
            <Rotulo nome="3.16 CONTRATADO?" cols="12 4">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                  margin-top: 5px;
                "
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    margin: 2px;
                  "
                >
                  <RadioButton
                    inputId="S"
                    name="flagContratado"
                    value="S"
                    v-model="registro.flagContratado"
                  />
                  <label for="S" style="margin-left: 10px; margin-right: 10px">
                    Sim</label
                  >
                  <RadioButton
                    inputId="N"
                    name="flagContratado"
                    value="N"
                    v-model="registro.flagContratado"
                  />
                  <label for="N" style="margin-left: 10px"> Não</label>
                </div>
              </div>
            </Rotulo>
            <Rotulo nome="3.17 DATA INÍCIO DO CONTRATO:" cols="12 4">
              <date-picker
                v-model="registro.dataIniContrato"
                valueType="format"
                title-format="DD/MM/YYYY"
                format="DD/MM/YYYY"
                class="grid-container"
                :disabled= "registro.flagContratado === 'N'"
              >
              </date-picker>
            </Rotulo>
            <Rotulo nome="3.18 DATA FIM DO CONTRATO:" cols="12 4">
              <date-picker
                v-model="registro.dataFimContrato"
                valueType="format"
                title-format="DD/MM/YYYY"
                format="DD/MM/YYYY"
                class="grid-container"
                :disabled= "registro.flagContratado === 'N'"
              >
              </date-picker>
            </Rotulo>
            <Rotulo
              nome="3.19 APROVADO EM PROCESSO SELETIVO? SE SIM, INFORMAR O ANO:"
              cols="12 4"
            >
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                  margin-top: 5px;
                "
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    margin: 2px;
                  "
                >
                  <RadioButton
                    inputId="S"
                    name="flagSeletivo"
                    value="S"
                    v-model="registro.flagSeletivo"
                  />
                  <label for="S" style="margin-left: 10px; margin-right: 10px">
                    Sim</label
                  >
                  <RadioButton
                    inputId="N"
                    name="flagSeletivo"
                    value="N"
                    v-model="registro.flagSeletivo"
                  />
                  <label for="N" style="margin-left: 10px"> Não</label>
                </div>
              </div>
            </Rotulo>
            <Rotulo nome="3.20 ANO SELETIVO:" cols="12 4">
              <InputMask
                v-model="registro.numrAnoSeletivo"
                mask="9999"
                placeholder="INFORME O ANO"
                :disabled= "registro.flagSeletivo === 'N'"
              />
            </Rotulo>
            <Rotulo nome="3.21 SERVIDOR CEDIDO?" cols="12 4" >
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                  margin-top: 5px;
                "
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    margin: 2px;
                  "
                >
                  <RadioButton
                    inputId="S"
                    name="flagServidorCedido"
                    value="S"
                    v-model="registro.flagServidorCedido"                
                  />
                  <label for="S" style="margin-left: 10px; margin-right: 10px">
                    Sim</label
                  >
                  <RadioButton
                    inputId="N"
                    name="flagServidorCedido"
                    value="N"
                    v-model="registro.flagServidorCedido"
                  />
                  <label for="N" style="margin-left: 10px"> Não</label>
                </div>
              </div>
            </Rotulo>
            <Rotulo nome="3.21.1 ÓRGÃO DE ORIGEM:" cols="12 6" 
                v-if="registro.flagServidorCedido == 'S'"
                :requerido="registro.flagServidorCedido ? true : false">
                <InputText
                type="text"
                v-model="registro.orgaoOrigem"             
                placeholder=""                      
              />             
            </Rotulo>
            <Rotulo nome="3.21.2 ÓRGÃO DE DESTINO" cols="12 6"
                v-if="registro.flagServidorCedido == 'S'"
                :requerido="registro.flagServidorCedido ? true : false">
                <InputText
                type="text"
                v-model="registro.orgaoDestino"
                placeholder=""                                   
              />    
            </Rotulo>
            <Rotulo nome="3.22 CPF VALIDADOR:" cols="12 4">
            <InputText
                type="text"
                v-model="registro.cpfValidador"
                placeholder="NOME VALIDADOR SELECIONADO"
                disabled              
              />
            </Rotulo>
            <Rotulo nome="3.23 NOME VALIDADOR:" cols="12 8">
              <InputText
                type="text"
                v-model="registro.nomeValidador"
                placeholder="NOME VALIDADOR SELECIONADO"
                disabled            
              />
           
           
           </Rotulo>
            <Rotulo
              nome="3.24 UPLOAD DOCUMENTOS FORMAÇÃO ACADÊMICA:"
              cols="12 6"
              ><br />
              <div class="p-col p-grid">
                <div
                  class="p-col-6"
                  v-if="
                    registro.arquivoFormacaoAcademica != null &&
                    registro.arquivoFormacaoAcademica.statArquivo == 'ENVIADO'
                  "
                >
                  <Button
                    label="Visualizar Arquivo"
                    icon="pi pi-file-pdf"
                    @click="visualizarArquivoFormacaoAcademica()"
                    class="p-button-warning button-visualizar-arquivo"
                  />
                </div>
                <div class="p-col-6">
                  <FileUpload
                    ref="fileUploadRefForma"
                    mode="basic"
                    name="file[]"
                    @uploader="onUploadChangeArquivoFormacaoAcademica"
                    accept="application/pdf,image/*"
                    :maxFileSize="2000000"
                    :auto="true"
                    invalidFileSizeMessage="Tamanho Máximo do Arquivo Não Permitido. Tamanho Máximo de 2 MB."
                    invalidFileTypeMessage="Tipo de Arquivo Não Permitido. Tipo Permitido: PDF, imagens"
                    @error="erroEnvioArquivo"
                    @select="validaSelecaoArquivo"
                    chooseLabel="Enviar arquivo"
                    :customUpload="true"
                  />
                </div>
              </div>

              <ExibirPDF
                v-if="pdfBase64FormacaoAcademica"
                v-model="exibirPDFDocumentoFormacaoAcademica"
                :tamanhoTela="'70.vw'"
                :alturaTela="'30.vw'"
                :tituloTela="nomeModalPDFFormacaoAcademica"
                :pdfElement="pdfBase64FormacaoAcademica"
              />
            </Rotulo>          
            <Rotulo cols="12 6" />
            <Rotulo nome="4. OBSERVAÇÕES:">
      <Textarea
        rows="5"
        v-model="registro.obsAdicionais"
        class="toUpperCase"
      ></Textarea>
            </Rotulo>
            <Rotulo nome="">
      <div class="p-col-12 mobile">
        <div class="p-grid p-fluid">
          <div class="p-col-8"></div>
          <div class="p-col-2">
            <Button
              label="Voltar"
              @click="voltar()"
              class="p-button-default"
              icon="pi pi-angle-left"
            />
          </div>
          <div class="p-col-2">
            <Button
              label="Salvar"
              icon="pi pi-save"
              class="p-button-success"
              @click="salvar()"
            />
          </div>
        </div>
      </div>
    </Rotulo>
          </div>
        </div>
      </div>
    </Panel>
    <Panel header="5. Protocolo" class="p-col-12">
        <Rotulo
              nome="5.1 UPLOAD FORMULÁRIO DE VALIDAÇÃO DE DADOS:"
              cols="12 6"
              ><br />
              <div class="p-col p-grid">
                <div
                  class="p-col-6"
                  v-if="
                    registro.arquivo != null &&
                    registro.arquivo.statArquivo == 'ENVIADO'
                  "
                >
                  <Button
                    label="Visualizar Arquivo"
                    icon="pi pi-file-pdf"
                    @click="visualizarArquivo()"
                    class="p-button-warning button-visualizar-arquivo"
                  />
                </div>
                <div class="p-col-6">
                  <FileUpload
                    ref="fileUploadRef"
                    mode="basic"
                    name="file[]"
                    @uploader="onUploadChangeArquivo"
                    accept="application/pdf,image/*"
                    :maxFileSize="2000000"
                    :auto="true"
                    invalidFileSizeMessage="Tamanho Máximo do Arquivo Não Permitido. Tamanho Máximo de 2MB."
                    invalidFileTypeMessage="Tipo de Arquivo Não Permitido. Tipo Permitido: PDF, imagem"
                    @error="erroEnvioArquivo"
                    @select="validaSelecaoArquivo"
                    chooseLabel="Enviar arquivo"
                    :customUpload="true"
                  />
                </div>
              </div>

              <ExibirPDF
                v-if="pdfBase64"
                v-model="exibirPDFDocumento"
                :tamanhoTela="'70.vw'"
                :alturaTela="'30.vw'"
                :tituloTela="nomeModalPDF"
                :pdfElement="pdfBase64"
              />
        </Rotulo>
      <div class="p-grid p-col-12">
        <b>{{
          registro.numrProtocolo != null ? registro.numrProtocolo : ""
        }}</b>
      </div>
    </Panel>
  
  </card-seplag>
</template>

<script>
import CardSeplag from "@/template/CardSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import InputNumber from "primevue/inputnumber";
import { baseApiUrl } from "@/config/global";
import { printToast } from "@/config/global";
import ExibirPDF from "@/template/CardExibirPDF.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";

const getFormulario = () => {
  return {
    idenPrefeituraCba: null,
    nomePessoa: null,
    descCpf: null,
    numrTelefone: null,
    descCargo: null,
    flagEfetivo: null,
    matricula: null,
    dataPosse: null,
    flagComissionado: null,
    dataNomeacao: null,
    flagContratado: null,
    dataIniContrato: null,
    flagSeletivo: null,
    numrAnoSeletivo: null,
    descUnidadeLotacao: null,
    descCargaHoraria: null,
    valrRemuneracao: null,
    flagRecebeAdicional: null,
    valrMedioAdicional: null,
    tipoRegistroPonto: null,
    dataNascimento: null,
    obsAdicionais: null,
    descValidaFrequencia: null,
    flagConfirmaLotacao: null,
    flagSalvo: null,
    dataAtualizacao: null,
    descEndereco: null,
    numrEndereco: null,
    nomeBairro: null,
    cidade: {
      idenCidade: null,
    },
    numrCep: null,
    email: null,
    numrMatricula: null,
    valorCargaHorariaSemanal: null,
    valorCargaHorariaDiaria: null,
    cpfValidador: null,
    nomeValidador: null,
    cpfChefia: null,
    nomeChefia: null,
    numrProtocolo: null,
    horaInicioTrabalho: null,
    horaFimTrabalho: null,
    uf: null,
  };
};
export default {
  name: "FORMPREFEITURA_FORMULARIO",
  components: { CardSeplag, Rotulo, InputNumber, ExibirPDF, DatePicker },

  data: function () {
    return {
      registro: getFormulario(),   
      cargos: null,
      unidades: null,
      ufs: [],
      cidades: [],
      resultadoBusca: null,
      textoBusca: null,
      resultadoBuscaValidador: null,
      textoBuscaValidador: null,
      inicioBaseApiUrl: baseApiUrl,
      exibirPDFDocumento: false,
      pdfBase64: "",
      nomeModalPDF: "MODAL PDF",
      exibirPDFDocumentoFormacaoAcademica: false,
      pdfBase64FormacaoAcademica: "",
      nomeModalPDFFormacaoAcademica: "MODAL PDF Formação Acadêmica",
    };
  },

  watch: {  
    'registro.flagContratado': function(valor) {
      if (valor == 'N') {
        this.registro.dataIniContrato = null;
        this.registro.dataFimContrato = null;
      }
    },

    'registro.flagComissionado': function(valor) {
      if (valor == 'N') {
        this.registro.dataPosse= null;
        this.registro.dataNomeacao = null;
      }
    },

    'registro.flagSeletivo': function(valor) {
      if (valor == 'N') {
        this.registro.numrAnoSeletivo= null;   
      }
    }
  },

  methods: {
    async carregarDados() {
      this.$http
        .get(
          `${baseApiUrl}/prefeituracba/${this.$route.params.idenPrefeituraCba}`
        )
        .then((res) => {
          this.registro = res.data;
          if (this.registro.cidade != null) {
            this.registro.uf = this.registro.cidade.uf;
            this.filtrarCidadePorIdenUf();
          }

          if (
            this.registro.cpfChefiaFormatado != null &&
            this.registro.cpfChefiaFormatado != ""
          ) {
            this.textoBusca = this.registro.cpfChefiaFormatado;
          }

          /*if (
            this.registro.cpfValidadorFormatado != null &&
            this.registro.cpfValidadorFormatado != ""
          ) {
            this.textoBuscaValidador = this.registro.cpfValidadorFormatado;
          }*/
          
        this.registro.cpfValidador = this.$store.getters.getUser.contaAcesso.pessoa.cpfFormatado;
        this.registro.nomeValidador = this.$store.getters.getUser.contaAcesso.pessoa.nomePessoa;

        });

      this.$http.get(`${baseApiUrl}/ufs/all`).then((res) => {
        this.ufs = res.data;
      });

      this.$http.get(`${baseApiUrl}/prefeituracba/unidades`).then((res) => {
        this.unidades = res.data;
      });

      this.$http.get(`${baseApiUrl}/prefeituracba/cargos`).then((res) => {
        this.cargos = res.data;
      });
     
    },

    salvar() {
      
      if (this.registro.tipoRegistroPonto === null) {
        this.registro.tipoRegistroPonto = "NAO_INFORMADO";
      }
      this.$http
        .put(
          `${baseApiUrl}/prefeituracba/${this.registro.idenPrefeituraCba}`,
          JSON.stringify(this.registro)
        )
        .then(() => {
          printToast({
            severity: "success",
            summary: "Sucesso",
            detail: "Registro alterado com sucesso",
          });
        });
    },

    changeForm() {
      this.isSalvo = false;
      this.$emit("changeForm", false);
    },

    changeUf() {
      this.filtrarCidadePorIdenUf();
      this.changeForm();
    },

    filtrarCidadePorIdenUf() {
      this.$http
        .get(`${baseApiUrl}/cidades/buscarPorIdenUf/${this.registro.uf.idenUf}`)
        .then((res) => {
          this.cidades = res.data;
        });
    },

    searchPessoa() {
      let qtdCaracteres = this.isNumber(this.textoBusca) ? 2 : 5;

      if (this.textoBusca.length >= qtdCaracteres) {
        this.$http
          .get(
            `${baseApiUrl}/prefeituracba/pesquisa/reduzida/${this.textoBusca}`
          )
          .then((res) => {
            this.resultadoBusca = res.data;
          });
      }
    },

    searchPessoaValidador() {
      let qtdCaracteres = this.isNumber(this.textoBuscaValidador) ? 2 : 5;
      if (this.textoBuscaValidador.length >= qtdCaracteres) {
        this.$http
          .get(
            `${baseApiUrl}/prefeituracba/pesquisa/reduzida/${this.textoBuscaValidador}`
          )
          .then((res) => {
            this.resultadoBuscaValidador = res.data;
          });
      }
    },

    selecionarChefia(evento) {
      this.registro.cpfChefia = evento.value.descCpf;
      this.registro.nomeChefia = evento.value.nomePessoa;
    },

    selecionarValidador(evento) {
      this.registro.cpfValidador = evento.value.descCpf;
      this.registro.nomeValidador = evento.value.nomePessoa;
    },

    isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },

    voltar() {
      this.$router.push({ name: "FORMPREFEITURA_MENU" });
    },

    visualizarArquivo() {
      this.$http
        .get(
          `${baseApiUrl}/arquivosprefcba/download/${this.registro.arquivo.idenArquivoPrefCba}`
        )
        .then((res3) => {
          this.pdfBase64 = res3.data;
          this.nomeModalPDF = "ARQUIVO FORMULÁRIO DIGITALIZADO";
          this.exibirPDFDocumento = true;
        });
    },

    visualizarArquivoFormacaoAcademica() {
      this.$http
        .get(
          `${baseApiUrl}/arquivosprefcba/download/${this.registro.arquivoFormacaoAcademica.idenArquivoPrefCba}`
        )
        .then((res3) => {
          this.pdfBase64FormacaoAcademica = res3.data;
          this.nomeModalPDFFormacaoAcademica = "DOCUMENTO FORMAÇÃO ACADÊMICA";
          this.exibirPDFDocumentoFormacaoAcademica = true;
        });
    },

    erroEnvioArquivo(event) {
      let response = JSON.parse(event.xhr.response);
      if (response.length > 0) {
        for (let i = 0; i < response.length; i++) {
          if (response[i].msgUsuario) {
            this.$toast.add({
              severity: "error",
              summary: "Erro ao enviar o arquivo",
              detail: response[i].msgUsuario,
              life: 10000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Erro ao enviar o arquivo",
              detail: response[i],
              life: 10000,
            });
          }
        }
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Erro ao enviar o arquivo",
          detail: response,
          life: 10000,
        });
      }
      this.$store.commit("setLoader", false);
    },

    validaSelecaoArquivo(event) {
      if (event.files && event.files.length > 0) {
        if (event.files[0].size > 2000000) {
          this.$toast.add({
            severity: "error",
            summary: "Erro ao enviar o arquivo",
            detail:
              "O tamanho do arquivo excede 2 megabytes, por favor informe um arquivo com até 2 MBs.",
            life: 5000,
          });
        }
      }
    },

    onUploadChangeArquivo(data) {
      
      this.registro.arquivo = null;

      let formData = new FormData();
      formData.append("file", data.files[0]);

      this.$http
        .put(
          `${baseApiUrl}/prefeituracba/upload/${this.registro.idenPrefeituraCba}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          printToast({
            severity: "success",
            summary: "Sucesso",
            detail: res.data,
          });

          this.$refs.fileUploadRef.clear();
          this.carregarDados();
        });
    },

    onUploadChangeArquivoFormacaoAcademica(data) {
      
      this.registro.arquivoFormacaoAcademica = null;

      let formData = new FormData();
      formData.append("file", data.files[0]);

      this.$http
        .put(
          `${baseApiUrl}/prefeituracba/upload/formacaoacademica/${this.registro.idenPrefeituraCba}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          printToast({
            severity: "success",
            summary: "Sucesso",
            detail: res.data,
          });

          this.$refs.fileUploadRefForma.clear();
          this.carregarDados();
        });
    },

    limpaCampoLotacao() {
      this.registro.descUnidLotacaoInformada = null;
    },
  },
  mounted() {
    this.carregarDados();
  },
};
</script>

<style>
.toUpperCase {
  text-transform: uppercase;
}

.toLowerCase {
  text-transform: lowercase;
}

.grid-container {
  width: 100%;
}
</style>